import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import ITariff from '@/interfaces/ITariff';

import TariffForm from '../TariffForm/TariffForm.vue';

@Component({
    name: 'TariffCreate',
    components: {
        CardHeader,
        TariffForm
    }
})
export default class TariffCreate extends Vue {
    @Action private createTariff!: (params: {form: ITariff, routeName?: string}) => Promise<void>;

    private form: ITariff = {
        paymentProviderId: 0,
        productId: '',
        price: '',
        public_key: '',
        billingStrategy: null
    };

    private handleTariffCreate(form: ITariff) {
        this.createTariff({form, routeName: this.$route.name || undefined });
    }
};


